








































import Vue from 'vue';
import api from '@/common/api';
import LoadingModal from '@/common/components/LoadingModal.vue';
import { initValidationErrors, ValidationErrors } from '@/common/validation/validation.types';
import { IpWhitelist, initIpWhitelist } from './support.types';

export default Vue.extend({
  data() {
    return {
      newIpWhitelist: initIpWhitelist() as IpWhitelist,
      isSubmitting: false as boolean,
      showModal: false as boolean,
      validationErrors: initValidationErrors() as ValidationErrors,
    };
  },
  methods: {
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    save() {
      if (!this.isValid()) {
        return;
      }

      this.submitActions(true);

      api
        .post('/ip-whitelists', {
          name: this.newIpWhitelist.name,
          ipAddress: this.newIpWhitelist.ipAddress,
        })
        .then(() => {
          this.newIpWhitelist = initIpWhitelist();
          this.$emit('created');
          (this.$refs.form as any).resetValidation();
          this.close();
        })
        .catch(({ response }: { response: any }) => {
          this.submitActions(false);
          if (response.status === 422) {
            const errors = response?.data?.errors;
            let msg: any = '';
            Object.keys(errors).forEach((key: any, idx: any) => {
              if (idx > 0) msg += '<br />';
              msg += `${errors[key]}`;
            });
            this.$toasted.error(msg);
          } else {
            this.$toasted.error(`There was a problem adding new Ip in Whitelist. (${response.status})`);
          }

          this.validationErrors = response.data.errors || {};
        });
    },
    show() {
      this.showModal = true;
    },
    close() {
      this.submitActions(false);
      this.newIpWhitelist = initIpWhitelist();
      this.showModal = false;
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
  },
  components: {
    LoadingModal,
  },
});
